import "../scss/pickup-time.scss";

jQuery( document.body ).on( 'updated_checkout', function(){
    jQuery('.periods').each(function(){
        if(jQuery('.period', jQuery(this)).length === 0){
            jQuery(this).css({color:'red'}).parent().addClass("day-empty");
        }
    });
});
